module.exports = __webpack_public_path__ + "static/media/exportIcon.eee131db.svg";